import React from 'react';
import Layout from '../layouts/index';
import BookImage from '../images/book-1000Vocabulary.png';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import { ReactPhotoCollage } from 'react-photo-collage';
import Recommended from '../components/Recommended';
import Payhip from '../components/Payhip';

class CourseDetails extends React.Component {
	render() {
		const setting = {
			width: '100%',
			height: ['500px', '170px'],
			layout: [1, 4],
			photos: [
				{
					source:
						'https://raw.githubusercontent.com/elingos/ElingosAssets/master/Assets/patterns-book1-preview/book1-page1.png',
				},
				{
					source:
						'https://raw.githubusercontent.com/elingos/ElingosAssets/master/Assets/patterns-book1-preview/book1-page2.png',
				},
				{
					source:
						'https://raw.githubusercontent.com/elingos/ElingosAssets/master/Assets/patterns-book1-preview/book1-page3.png',
				},
				{
					source:
						'https://raw.githubusercontent.com/elingos/ElingosAssets/master/Assets/patterns-book1-preview/book1-page4.png',
				},
			],
			showNumOfRemainingPhotos: true,
		};
		return (
			<Layout>
				{/* Course info */}
				<div className="container-fluid margin-from-header bg-white">
					<div className="container pt-4 pt-md-8 pb-8">
						<div className="row d-flex justify-content-md-center reverse-flex-mobile">
							<div className="col-sm-12 col-md-5 d-flex flex-column justify-content-left mr-md-6">
								<h2>1000 Essential Vietnamese Vocabulary</h2>
								<p>
									This free book contains vocabulary that every learner should
									know!
								</p>
								<p>
									Level: <b>Beginner</b>
								</p>
								<div className="row pl-1 mt-2">
									<Payhip productID="9jWbH" label="Get now for Free"></Payhip>
									{/* <OutboundLink
                    className="btn-simple btn-primary-outline "
                    href="https://gum.co/xsdrc?wanted=true"
                  >
                    Get now for Free
                  </OutboundLink> */}
								</div>
							</div>

							<div className="col-7 col-md-3 mb-2 align-self-center">
								<img
									src={BookImage}
									className="img-fluid float-right rounded"
									alt="1000 Essential Vietnamese Vocabulary"
								></img>
							</div>
						</div>
					</div>
				</div>

				{/* Course contents */}
				<div className="container pt-md-10 pb-md-10 pt-6 pb-6">
					<div className="row justify-content-md-center">
						<div className="col-sm-12 col-md-8 ml-1 mr-1">
							<h2>What will you achieve?</h2>
							<ul>
								<li>
									Learn 1000 essential Vietnamese words, including nouns, verbs,
									adjective, etc.
								</li>
								<li>
									All words are listed in alphabetical order, including Northern
									and Southern words.
								</li>
								<li>
									BONUS: Learn basic Vietnamese pronunciation: Vowels,
									Consonants and Tones.
								</li>
							</ul>
							{/* <h2 className="pt-8">Book Preview</h2>
							<ReactPhotoCollage {...setting} /> */}
							<h2 className="pt-6">What's included?</h2>
							<ul>
								<li>PDF eBook version - 1 file</li>
								<li>EPUB eBook version - 1 file</li>
							</ul>
						</div>
					</div>
				</div>

				<Recommended
					recommended={[
						'/vietnamese-ebook-bundle',
						'/vietnamese-grammar-book-bundle',
					]}
				/>
			</Layout>
		);
	}
}

export default CourseDetails;
